import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGoogleAuthState, IGoogleAuthSecret, IVerifyCodeResponse } from '../../../types/googleAuth/googleAuthInterfaces';

export const initialState: IGoogleAuthState = {
    qrGenerated: false,
    twoFactorEnabled: false,
    secret: null,
    otpAuthUrl: '',
    isValid: false,
    loading: false,
    checkingStatus: false,
    error: null,
};

export const twoFactorAuthSlice = createSlice({
    name: 'twoFactorAuth',
    initialState,
    reducers: {
        setQrGenerated: (state, action: PayloadAction<boolean>) => {
            // console.log('QrGenerated', action.payload);
            state.qrGenerated = action.payload;
        },
        setTwoFactorEnabled: (state, action: PayloadAction<boolean>) => {
            // console.log('TwoFactorEnabled', action.payload);
            state.twoFactorEnabled = action.payload;
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setCheckingStatus(state, action: PayloadAction<boolean>) {
            state.checkingStatus = action.payload;
        },
        setSecret(state, action: PayloadAction<IGoogleAuthSecret>) {
            state.secret = action.payload.secret;
            state.otpAuthUrl = action.payload.otpAuthUrl;
            state.isValid = false;
        },
        verifyCodeSuccess(state, action: PayloadAction<IVerifyCodeResponse>) {
            state.isValid = action.payload.activated;
            state.error = '';
        },
        verifyCodeFailure(state, action: PayloadAction<string>) {
            state.error = action.payload;
        },
        reset2FA(state) {
            state.secret = null;
            state.otpAuthUrl = '';
            state.isValid = false;
        },
        setError(state, action: PayloadAction<string | null>) {
            state.error = action.payload;
        },
    },
});

export const {
    setQrGenerated,
    setTwoFactorEnabled,
    setLoading,
    setCheckingStatus,
    setSecret,
    verifyCodeSuccess,
    verifyCodeFailure,
    reset2FA,
    setError,
} = twoFactorAuthSlice.actions;

export default twoFactorAuthSlice.reducer;
